export default "__VITE_ASSET__2V5p7$S4__"